module.exports = __webpack_public_path__ + "static/media/bbb.ae6f1483.svg";